import ApiConstant from "../../constants/api.constants";
import { AssignCode } from "../../models/route-code/routecode-model"; 
import api from "../api";

interface AssignRouteCodeResponse {
routeCodes: any[];
totalRecords: number;
}

interface FilterParams {
pageNumber?: number;
pageSize?: number;
keyword?: string | null;
userID?: number| null;
routeCodeID?: number[];
}

const GetAllAssignRouteCode = async (pageNumber: number, pageSize: number): Promise<AssignRouteCodeResponse> => {
try {
const response = await api.post(ApiConstant.Assignroutecode2, {
pageNumber,
pageSize
});

return {
routeCodes: response?.data?.routeCodes || [],
totalRecords: response?.data?.totalRecords || 0
};
}
catch (error) {
console.error("Error in GetAllAssignRouteCode:", error);
return {
routeCodes: [],
totalRecords: 0
};
}
};

const FilterAssignRouteCode = async (filter: FilterParams): Promise<AssignRouteCodeResponse> => {
try {
const requestBody = {
PageNumber: filter.pageNumber,
PageSize: filter.pageSize,
Keyword: filter.keyword || null,
UserID: filter.userID || null,
RouteCodeID: filter.routeCodeID || []
};

const response = await api.post(ApiConstant.FilterAssignRouteCodes, requestBody);

return {
routeCodes: response?.data?.routeCodes || [],
totalRecords: response?.data?.totalRecords || 0
};
} catch (error) {
console.error("Error in FilterAssignRouteCode:", error);
return {
routeCodes: [],
totalRecords: 0
};
}
};

const getRouteCodes = async () => {  
    try {
        const RouteCodes: any = await api
        .get(ApiConstant.getRouteCodesApi)
        .then((result: any)=> {
            if(result)            
                return result.data;
            else
                return null;         
         })
         .catch(function (error: any) {
             console.error('error reading get route code data.', error);
         });
        const response = RouteCodes != null ? RouteCodes : null;        
        return response;
    }
    catch (e) {
        console.log('error in getRouteCodes');
        return [];
    } 
}

const saveRouteCodes = async (newRouteCode: any) => {  
    try {
        const RouteCodes: any = await api
        .post(ApiConstant.getRouteCodesApi,newRouteCode)
        .then((result: any)=> {
            if(result)            
                return result.data;
            else
                return null;         
         })
         .catch(function (error: any) {
             console.error('error reading get route code data.', error);
         });
        const response = RouteCodes != null ? RouteCodes : null;        
        return response;
    }
    catch (e) {
        console.log('error in getRouteCodes');
        return [];
    } 
}
const updateRouteCodes = async (updateRouteCodes: any) => {  
    try {
        const RouteCodes: any = await api
        .put(ApiConstant.getRouteCodesApi,updateRouteCodes)
        .then((result: any)=> {
            if(result)            
                return result.data;
            else
                return null;         
         })
         .catch(function (error: any) {
             console.error('error reading get route code data.', error);
         });
        const response = RouteCodes != null ? RouteCodes : null;        
        return response;
    }
    catch (e) {
        console.log('error in getRouteCodes');
        return [];
    } 
}
const deleteRouteCode = async (addressId: number) => {
    try {
      console.warn(ApiConstant.deleteRouteCodeApi + addressId);
      await api
        .delete(ApiConstant.deleteRouteCodeApi + addressId)
        .then((res: any) => {
          if (res) return res.data;
          else return null;
        })
        .catch(function (error: any) {
          console.error("error deleting Routes data.", error);
        });
    } catch {
      console.log("error in Routes user address");
      return;
    }
  };
const getUsers = async (filter: string) => {  
    try {
        const routeCodeUsers: any = await api
        .get(ApiConstant.getRouteCodeUsers + filter)
        .then((result: any)=> {
            if(result)            
                return result.data;
            else
                return null;         
         })
         .catch(function (error: any) {
             console.error('error reading get route code data.', error);
         });
        const response = routeCodeUsers != null ? routeCodeUsers : null;        
        return response;
    }
    catch (e) {
        console.log('error in getRouteCodes');
        return [];
    } 
}

const assignRouteCode1 = async (data: AssignCode) => {
    try {
        const response = await api.put(ApiConstant.updateUserRouteCode, data);
        return response.data; 
    } catch (error) {
        console.error("❌ Error updating route code:", error);
        return { isSuccess: false };
    }
}



// const GetAllAssignRouteCode = async (pageNumber: number, pageSize: number) => {
//     try {
//         const requestData = {
//             pageNumber,
//             pageSize,
//         };

//         const response = await api
//             .post(ApiConstant.assignUserRouteCode, requestData)
//             .then((res: any) => {
//                 if (res && res.data) {
//                     console.log("res is:",res);
//                     return res.data; // Ensure the correct data is returned
//                 } else {
//                     return null;
//                 }
//             })
//             .catch((error: any) => {
//                 console.error("Error fetching Address:", error);
//             });

//         return response ? response : null;
//     } catch (e) {
//         console.log("Error in fetching address");
//         return []; // In case of an error, return an empty array
//     }
// };



const routeCodeServices = {
    getRouteCodes,
    saveRouteCodes,
    updateRouteCodes,
    deleteRouteCode,
    getUsers,
    assignRouteCode1,
    GetAllAssignRouteCode,
    FilterAssignRouteCode
};

export default routeCodeServices;